var _radialGradient, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTubeSpinner = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200"
}, props), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
  id: "a",
  cx: 0.66,
  cy: 0.313,
  fx: 0.66,
  fy: 0.313,
  gradientTransform: "scale(1.5)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "currentColor"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "currentColor",
  stopOpacity: 0.9
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "currentColor",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "currentColor",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "currentColor",
  stopOpacity: 0
}))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 100,
  r: 70,
  fill: "none",
  stroke: "url(#a)",
  strokeDasharray: "200 1000",
  strokeLinecap: "round",
  strokeWidth: 25,
  "transform-origin": "center"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  calcMode: "spline",
  dur: 1.2,
  keySplines: "0 0 1 1",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "rotate",
  values: "360;0"
}))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 100,
  r: 70,
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 25,
  opacity: 0.2,
  "transform-origin": "center"
})));
export { SvgTubeSpinner as ReactComponent };
export default __webpack_public_path__ + "assets/media/tube-spinner.25959d7f2b7f1002952dcb516e95c3d5.svg";